import LoanForm from './LoanForm.vue';

export default LoanForm;
